const Scoreboard = ({ score }) => (
  <div className="scoreBoard">
    Scoreboard
    <div className="board">
      <p>{score.player}</p>
      <div className="line" />
      <p>{score.computer}</p>
    </div>
  </div>
);

export default Scoreboard;
